<template>
    <div style="text-align:left;">
        <a-button style="margin-top:20px;" type="primary" @click="ShowModal">
            {{ i18n.$t('ToolVersionUpdateModalButton') }}
        </a-button>
        <a-modal
            :title="i18n.$t('ToolVersionUpdateModalTitle')"
            :width = "600"
            :visible="ModalVisible"
            :ok-button-props="ConfirmLoading"
            :cancel-button-props="ConfirmLoading"
            ok-text="Push"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolFile')">
                    <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :multiline="false">
                        <a-button>
                            <upload-outlined></upload-outlined>
                            Select File
                        </a-button>
                    </a-upload>
                    <!-- <a-button
                        type="primary"
                        :disabled="fileList.length === 0"
                        :loading="uploading"
                        style="margin-top: 16px"
                        @click="handleUpload"
                    >
                        {{ uploading ? 'Uploading' : 'Start Upload' }}
                    </a-button> -->
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolId')">
                   <a-input disabled v-model:value="ToolVersionUpdateForm.id" :placeholder="i18n.$t('ToolVersionUpdateFormToolIdPH')" />
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolName')">
                   <a-input readonly v-model:value="ToolVersionUpdateForm.name" :placeholder="i18n.$t('ToolVersionUpdateFormToolNamePH')" />
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolSize')">
                   <a-input readonly v-model:value="ToolVersionUpdateForm.size" :placeholder="i18n.$t('ToolVersionUpdateFormToolToolSizes')" />
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolVersionNumber')">
                   <a-textarea readonly v-model:value="ToolVersionUpdateForm.version" :placeholder="i18n.$t('ToolVersionUpdateFormToolVersionNumberPH')" />
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolVersionInfo')">
                   <a-textarea v-model:value="ToolVersionUpdateForm.releaseNote" :placeholder="i18n.$t('ToolVersionUpdateFormToolVersionInfoPH')" />
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateTabelVersionUpdateTime')">
                    <a-date-picker v-model:value="ToolVersionUpdateForm.releaseTime" valueFormat='YYYY-MM-DD'/>
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormForceUpdate')">
                    <a-radio-group v-model:value="ToolVersionUpdateForm.forceUpdate">
                        <a-radio :value="true">Yes</a-radio>
                        <a-radio :value="false">No</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolVersionType')">
                    <a-radio-group v-model:value="ToolVersionUpdateForm.versionType">
                        <a-radio value="formal">Formal Version</a-radio>
                        <a-radio value="test">Test Version</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormCountry')">
                    <a-select mode="multiple" v-model:value="ToolVersionUpdateForm.countries" show-search placeholder="please select your Country" option-filter-prop="children">
                        <a-select-option v-for="country in CountryList" :value="country.id" :key="country.id">{{ country.name }}</a-select-option>
                    </a-select>
                    <!-- <a-button style="margin-top:20px;" type="primary" @click="SelectAllCountry()">
                        {{ i18n.$t('ToolVersionUpdateSelectAllButton') }}
                    </a-button> -->
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormToolClassify')">
                    <a-select v-model:value="ToolVersionUpdateForm.typeId" placeholder="please select your Classify">
                        <a-select-option v-for="SoftType in SoftTypeList" :value="SoftType.id" :key="SoftType.id">{{ SoftType.name }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="i18n.$t('ToolVersionUpdateFormTips')">
                   <a-textarea v-model:value="ToolVersionUpdateForm.tips" :placeholder="i18n.$t('ToolVersionUpdateFormTipsPH')" />
                </a-form-item>
            </a-form>
        </a-modal>
        <a-table 
            bordered
            :data-source="ToolVersionUpdateData"
            :columns="columns"
            :pagination="pagination"
            @change="handleTableChange"
            :row-key="record => record.id"
            :scroll="{ x: 1040 }">
            <template #operation="{ record }">
                <a-button type="primary" @click="ShowModalEdit(record)">{{ i18n.$t('ToolVersionUpdateTabelEdit') }}</a-button>
                <a-popconfirm
                    v-if="ToolVersionUpdateData.length"
                    title="Sure to delete?"
                    @confirm="onDelete(record.id)"
                >
                    <a-button style="margin-top:5px;" type="danger">{{ i18n.$t('ToolVersionUpdateTabelDelete') }}</a-button>
                </a-popconfirm>
            </template>
            <template #ForceUpdate="{ record }">
                <label v-if="record.forceUpdate" >Yes</label>
                <label v-else >No</label>
            </template>
            <template #Country="{ record }">
                <label v-for="Country in record.countries" >{{Country.name}},</label>
            </template>
            <template #typeid="{ record }">
                <label >{{record.type}}</label>
            </template>
        </a-table>
    </div>
</template>

<script>
import { useI18n } from "@/i18nPlugin";
import { defineComponent, ref } from "vue";
import { UploadOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import md5 from 'js-md5';
import {
    SearchVersionUpdateData,
    AddVersionUpdateData,
    EditVersionUpdateData,
    DeleteVersionUpdateData,
    SearchCountryListData,
    SearchSoftTypeListData,
    bigFileUploadData,
    bigFileUploadMergeData
} from '../api/index';


export default defineComponent({
    components: {
        UploadOutlined,
    },
    mounted() {
        this.SearchCountryList();
        this.SearchSoftTypeList();
        this.SearchVersionUpdate();
    },
    setup() {
        const i18n = useI18n();
        const token = localStorage.getItem("userToken");
        const CountryList = ref([]);
        const SoftTypeList = ref([]);
        const SearchCountryList = () => {
            SearchCountryListData (token).then(res => {   
                CountryList.value = res.data;
            }).catch(error => console.log(error));
        };
        const SearchSoftTypeList = () => {
            SearchSoftTypeListData (token).then(res => {   
                SoftTypeList.value = res.data;
                console.log(SoftTypeList._rawValue)
            }).catch(error => console.log(error));
        };
        const SearchVersionUpdate = () => {
            SearchVersionUpdateData (token).then(res => {   
                if(res.status == 200){
                    ToolVersionUpdateData.value = res.data;
                    pagination.value.total = res.total;
                }
            }).catch(error => console.log(error));
        };
        const columns =  ref([
            {
                title: i18n.$t('ToolVersionUpdateFormToolId'),
                width: 150,
                dataIndex: 'id',
                fixed: 'left'
            },
            {
                title: i18n.$t('ToolVersionUpdateFormToolName'),
                width: 150,
                dataIndex: 'name',
            },
            {
                title: i18n.$t('ToolVersionUpdateFormToolSize'),
                width: 150,
                dataIndex: 'size',
            },
            {
                title: i18n.$t('ToolVersionUpdateFormToolVersionNumber'),
                width: 150,
                dataIndex: 'version',
            },
            {
                title: i18n.$t('ToolVersionUpdateTabelVersionUpdateTime'),
                width: 200,
                dataIndex: 'releaseTime',
            },
            {
                title: i18n.$t('ToolVersionUpdateFormToolVersionInfo'),
                width: 250,
                dataIndex: 'releaseNote',
            },
            {
                title: i18n.$t('ToolVersionUpdateFormForceUpdate'),
                width: 150,
                dataIndex: 'forceUpdate',
                slots: { customRender: 'ForceUpdate' },
            },
            {
                title: i18n.$t('ToolVersionUpdateFormToolVersionType'),
                width: 150,
                dataIndex: 'versionType',
            },
            {
                title: i18n.$t('ToolVersionUpdateFormCountry'),
                width: 150,
                dataIndex: 'countries',
                slots: { customRender: 'Country' },
            },
            {
                title: i18n.$t('ToolVersionUpdateFormToolClassify'),
                width: 150,
                dataIndex: 'type',
                slots: { customRender: 'typeid' },
            },
            {
                title: i18n.$t('ToolVersionUpdateFormTips'),
                width: 150,
                dataIndex: 'tips',
            },
            {
                title: i18n.$t('ToolVersionUpdateTabelCreatetime'),
                width: 150,
                dataIndex: 'createTime',
            },
            {
                title: i18n.$t('ToolVersionUpdateTabelCreater'),
                width: 150,
                dataIndex: 'ownerName',
            },
            {
                title: i18n.$t('ToolVersionUpdateTabelOperation'),
                dataIndex: 'operation',
                fixed: 'right',
                width: 100,
                slots: { customRender: 'operation' },
            },
        ]);
        let ToolVersionUpdateData =  ref([]);
        const pagination =  ref({
            total: 0,
            showTotal: total => `共 ${total} 条数据`,
        });
        const loading =  ref(false);
        const ModalVisible = ref(false);
        const ConfirmLoading = ref({ disabled: false });
        const labelCol = ref({ span: 6 })
        const wrapperCol = ref({ span: 18 })
        const ShowModal = () => {
            fileList.value = []
            ToolVersionUpdateForm.value.id = ""
            ToolVersionUpdateForm.value.name = ""
            ToolVersionUpdateForm.value.path = ""
            ToolVersionUpdateForm.value.size = 0
            ToolVersionUpdateForm.value.version = ""
            ToolVersionUpdateForm.value.releaseTime = ""
            ToolVersionUpdateForm.value.releaseNote = ""
            ToolVersionUpdateForm.value.forceUpdate = true
            ToolVersionUpdateForm.value.typeId = ""
            ToolVersionUpdateForm.value.versionType = "formal"
            ToolVersionUpdateForm.value.countries = []
            ToolVersionUpdateForm.value.tips = ""
            ModalVisible.value = true;
        }
        const handleOk = () => {
            if(ToolVersionUpdateForm.value.name == "") {
                message.error("Please choose file");
                return false;
            }
            if(ToolVersionUpdateForm.value.version == "") {
                message.error("Please choose file");
                return false;
            }
            if(ToolVersionUpdateForm.value.releaseTime == "" || ToolVersionUpdateForm.value.releaseTime == null) {
                message.error("ReleaseTime can not be blank");
                return false;
            }
            if(ToolVersionUpdateForm.value.releaseNote == "") {
                message.error("ReleaseNote can not be blank");
                return false;
            }
            if(ToolVersionUpdateForm.value.countries == "") {
                message.error("Countries can not be blank");
                return false;
            }
            if(ToolVersionUpdateForm.value.typeId == "") {
                message.error("Tool Classify can not be blank");
                return false;
            }
            if(ToolVersionUpdateForm.value.tips == "") {
                message.error("Tips can not be blank");
                return false;
            }
            ConfirmLoading.value = { disabled: true }

            //文件切片上传
            let fileTemp = fileList.value[0];
            if (fileTemp) {
                let GUID =  md5(fileTemp.name+'#'+fileTemp.lastModified+'#'+fileTemp.size+'#'+fileTemp.type);
                let axiosArray = [];
                let chunkList = [];
                let chunkSize = fileTemp.size / 4;
                let current = 0;
                let i = 0;
                // let fileName = new Date().getTime() + "_" + fileTemp.name;
                let fileName = fileTemp.name;
                while (current < 4) {
                    chunkList.push({
                        chunk: fileTemp.slice(current * chunkSize, (current + 1) * chunkSize),
                        fileName: current + "_" + fileName
                    });
                    current++;
                }
                chunkList.map(function(item) {
                    let form = new FormData();
                    form.append("guid", GUID);
                    form.append("file", item.chunk);
                    form.append("fileName", item.fileName);
                    axiosArray.push(
                        bigFileUploadData(form,token).then(res=> {
                            console.log(res)
                        }).catch(e=>{
                            console.log(e)
                        })
                    );
                });
                Promise.all(axiosArray).then(res => {
                    bigFileUploadMergeData({
                        guid: GUID,
                        fileName: fileName
                    },token).then(res=> {
                        console.log(res)
                        const formData = new FormData();
                        const fileUrl = res.data;
                        if(ToolVersionUpdateForm.value.id == ""){
                            formData.append('fileUrl', fileUrl);
                            formData.append('name', ToolVersionUpdateForm.value.name);
                            formData.append('size', ToolVersionUpdateForm.value.size);
                            formData.append('version', ToolVersionUpdateForm.value.version);
                            formData.append('releaseTime', ToolVersionUpdateForm.value.releaseTime);
                            formData.append('releaseNote', ToolVersionUpdateForm.value.releaseNote);
                            formData.append('forceUpdate', ToolVersionUpdateForm.value.forceUpdate);
                            formData.append('typeId', ToolVersionUpdateForm.value.typeId);
                            formData.append('versionType', ToolVersionUpdateForm.value.versionType);
                            for (var i = 0; i < ToolVersionUpdateForm.value.countries.length; i++) {
                                formData.append('countries', ToolVersionUpdateForm.value.countries[i]); 
                            }
                            formData.append('tips', ToolVersionUpdateForm.value.tips);
                            // ConfirmLoading.value = true;
                            AddVersionUpdateData (formData,token).then(res => {
                                if(res.status == 200) {
                                    SearchVersionUpdate();
                                    message.success('Success');
                                    ConfirmLoading.value = { disabled: false }
                                    ModalVisible.value = false;
                                }
                            }).catch(error => {
                                ConfirmLoading.value = { disabled: false }
                                console.log(error);
                            })
                        }else{
                            formData.append('id', ToolVersionUpdateForm.value.id);
                            if(fileList.value[0] != undefined) {
                                formData.append('fileUrl', fileUrl);
                            }
                            formData.append('name', ToolVersionUpdateForm.value.name);
                            formData.append('size', ToolVersionUpdateForm.value.size);
                            formData.append('version', ToolVersionUpdateForm.value.version);
                            formData.append('releaseTime', ToolVersionUpdateForm.value.releaseTime);
                            formData.append('releaseNote', ToolVersionUpdateForm.value.releaseNote);
                            formData.append('forceUpdate', ToolVersionUpdateForm.value.forceUpdate);
                            formData.append('typeId', ToolVersionUpdateForm.value.typeId);
                            formData.append('versionType', ToolVersionUpdateForm.value.versionType);
                            for (var i = 0; i < ToolVersionUpdateForm.value.countries.length; i++) {
                                formData.append('countries', ToolVersionUpdateForm.value.countries[i]);  
                            }
                            // formData.append('countries', ToolVersionUpdateForm.value.countries);
                            formData.append('tips', ToolVersionUpdateForm.value.tips);
                            // ConfirmLoading.value = true;
                            EditVersionUpdateData (formData,token).then(res => {
                                // console.log(res.status)
                                if(res.status == 200) {
                                    SearchVersionUpdate();
                                    message.success('Success');
                                    ConfirmLoading.value = { disabled: false }
                                    ModalVisible.value = false;
                                }
                            }).catch(error => {
                                ConfirmLoading.value = { disabled: false }
                                console.log(error);
                            })
                        }
                        console.log(formData)
                    }).catch(e=> {
                        console.log(e)
                    })
                });
            }else {
                const formData = new FormData();
                if(ToolVersionUpdateForm.value.id == ""){
                    formData.append('fileUrl', ToolVersionUpdateForm.value.path);
                    formData.append('name', ToolVersionUpdateForm.value.name);
                    formData.append('size', ToolVersionUpdateForm.value.size);
                    formData.append('version', ToolVersionUpdateForm.value.version);
                    formData.append('releaseTime', ToolVersionUpdateForm.value.releaseTime);
                    formData.append('releaseNote', ToolVersionUpdateForm.value.releaseNote);
                    formData.append('forceUpdate', ToolVersionUpdateForm.value.forceUpdate);
                    formData.append('typeId', ToolVersionUpdateForm.value.typeId);
                    formData.append('versionType', ToolVersionUpdateForm.value.versionType);
                    for (var i = 0; i < ToolVersionUpdateForm.value.countries.length; i++) {
                        formData.append('countries', ToolVersionUpdateForm.value.countries[i]); 
                    }
                    formData.append('tips', ToolVersionUpdateForm.value.tips);
                    // ConfirmLoading.value = true;
                    AddVersionUpdateData (formData,token).then(res => {
                        if(res.status == 200) {
                            SearchVersionUpdate();
                            message.success('Success');
                            ConfirmLoading.value = { disabled: false }
                            ModalVisible.value = false;
                        }
                    }).catch(error => {
                        ConfirmLoading.value = { disabled: false }
                        console.log(error);
                    })
                }else{
                    formData.append('id', ToolVersionUpdateForm.value.id);
                    formData.append('fileUrl', ToolVersionUpdateForm.value.path);
                    formData.append('name', ToolVersionUpdateForm.value.name);
                    formData.append('size', ToolVersionUpdateForm.value.size);
                    formData.append('version', ToolVersionUpdateForm.value.version);
                    formData.append('releaseTime', ToolVersionUpdateForm.value.releaseTime);
                    formData.append('releaseNote', ToolVersionUpdateForm.value.releaseNote);
                    formData.append('forceUpdate', ToolVersionUpdateForm.value.forceUpdate);
                    formData.append('typeId', ToolVersionUpdateForm.value.typeId);
                    formData.append('versionType', ToolVersionUpdateForm.value.versionType);
                    for (var i = 0; i < ToolVersionUpdateForm.value.countries.length; i++) {
                        formData.append('countries', ToolVersionUpdateForm.value.countries[i]);  
                    }
                    // formData.append('countries', ToolVersionUpdateForm.value.countries);
                    formData.append('tips', ToolVersionUpdateForm.value.tips);
                    // ConfirmLoading.value = true;
                    EditVersionUpdateData (formData,token).then(res => {
                        // console.log(res.status)
                        if(res.status == 200) {
                            SearchVersionUpdate();
                            message.success('Success');
                            ConfirmLoading.value = { disabled: false }
                            ModalVisible.value = false;
                        }
                    }).catch(error => {
                        ConfirmLoading.value = { disabled: false }
                        console.log(error);
                    })
                }
            }


            
        }
        const handleCancel = () => {
            ModalVisible.value = false;
        }
        const SelectAllCountry = () => {
            ToolVersionUpdateForm.value.countries = []
            CountryList.value.forEach(element => {
                ToolVersionUpdateForm.value.countries.push(element.id)
            });
        }
        const ToolVersionUpdateForm = ref({
            id: "",
            name: "",
            path: "",
            size: 0,
            version: "",
            releaseTime: "",
            releaseNote: "",
            forceUpdate: true,
            typeId: "",
            versionType: "",
            countries: [],
            tips: "",
            createTime: "",
            ownerName: ""
        });
        const ShowModalEdit = (record) => {
            fileList.value = []
            const countryEdit = []
            record.countries.forEach(element => {
                countryEdit.push(element.id)
            });
            ToolVersionUpdateForm.value.id = record.id
            ToolVersionUpdateForm.value.name = record.name
            ToolVersionUpdateForm.value.path = record.path
            ToolVersionUpdateForm.value.size = record.size
            ToolVersionUpdateForm.value.version = record.version
            ToolVersionUpdateForm.value.releaseTime = record.releaseTime
            ToolVersionUpdateForm.value.releaseNote = record.releaseNote
            ToolVersionUpdateForm.value.forceUpdate = record.forceUpdate
            ToolVersionUpdateForm.value.typeId = record.type.id
            ToolVersionUpdateForm.value.versionType = record.versionType
            ToolVersionUpdateForm.value.countries = countryEdit
            ToolVersionUpdateForm.value.tips = record.tips
            ModalVisible.value = true;
        }
        const onDelete = (id) => {
            DeleteVersionUpdateData ({
                id: id
            },token).then(res => {
                if(res.status == 200){
                    message.success('Success');
                    const TempToolVersionUpdateData = [...ToolVersionUpdateData.value];
                    ToolVersionUpdateData.value = TempToolVersionUpdateData.filter(item => item.id !== id);
                }
            }).catch(error => {
                // this.$message.danger('添加失败');
                console.log(error);
            })
        }
        const handleTableChange =(pagination, filters, sorter) => {
            console.log(pagination);
            console.log(filters);
            console.log(sorter); 
        };
        const fileList = ref([]);
        const uploading = ref(false);

        const handleRemove = (file) => {
            const index = fileList.value.indexOf(file);
            const newFileList = fileList.value.slice();
            newFileList.splice(index, 1);
            fileList.value = newFileList;
        };

        const beforeUpload = (file) => {
            fileList.value = []
            fileList.value = [...fileList.value, file];
            let filenamesplice = file.name.split('_');
            ToolVersionUpdateForm.value.name = filenamesplice[filenamesplice.length-2];
            ToolVersionUpdateForm.value.size = file.size;
            ToolVersionUpdateForm.value.version = filenamesplice[filenamesplice.length-1].split('.zip')[0];
            return false;
        };

        return {
            i18n,
            token,
            SearchVersionUpdate,
            CountryList,
            SearchCountryList,
            SoftTypeList,
            SearchSoftTypeList,
            ToolVersionUpdateData,
            ToolVersionUpdateForm,
            ModalVisible,
            labelCol,
            wrapperCol,
            ConfirmLoading,
            ShowModal,
            handleOk,
            handleCancel,
            ShowModalEdit,
            handleTableChange,
            pagination,
            loading,
            columns,
            onDelete,
            fileList,
            uploading,
            handleRemove,
            beforeUpload,
            SelectAllCountry
        }
    }
})

</script>
